import { render, staticRenderFns } from "./MedicoSolicitanteCriar.vue?vue&type=template&id=0137110c"
import script from "./MedicoSolicitanteCriar.vue?vue&type=script&lang=js"
export * from "./MedicoSolicitanteCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports